import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { Ship, Landmark, Package, CheckCircle2 } from 'lucide-react';
import type { ImportDashboardStats } from '../types/import-tracking.types';

interface ImportStatsCardsProps {
  stats: ImportDashboardStats | null;
  isLoading?: boolean;
}

export function ImportStatsCards({ stats, isLoading }: ImportStatsCardsProps) {
  if (isLoading || !stats) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <Card key={i}>
            <CardContent className="p-4">
              <Skeleton className="h-4 w-20 mb-2" />
              <Skeleton className="h-8 w-16" />
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  const cards = [
    {
      label: 'Activas',
      value: stats.totalActive,
      icon: Package,
      color: 'text-primary bg-info-suave',
    },
    {
      label: 'En tránsito',
      value: stats.inTransit,
      icon: Ship,
      color: 'text-alerta bg-alerta-suave',
    },
    {
      label: 'En aduana',
      value: stats.inCustoms,
      icon: Landmark,
      color: 'text-alerta bg-alerta-suave',
    },
    {
      label: 'Entregadas (30d)',
      value: stats.deliveredThisMonth,
      icon: CheckCircle2,
      color: 'text-ok bg-ok-suave',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {cards.map((card) => {
        const Icon = card.icon;
        return (
          <Card key={card.label}>
            <CardContent className="p-4 flex items-center gap-3">
              <div className={`p-2 rounded-lg ${card.color}`}>
                <Icon className="w-5 h-5" />
              </div>
              <div>
                <p className="text-xs text-muted-foreground">{card.label}</p>
                <p className="text-2xl font-bold">{card.value}</p>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
